<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="用户编辑" :header-visible="true" />
    <!--快捷回访 部分 S-->
    <div class="line_02"><span>客户状态</span></div>
    <el-form
      ref="visitForm"
      :model="visitShadow"
      :rules="rules"
      style="width: 100vw;overflow: hidden;"
      label-width="25vw">
      <el-form-item
        label="客户编码："
        prop="userid">
        <el-input
          class="jm-input220"
          placeholder="请输入客户编码"
          v-model="visitShadow['userid']"/>
      </el-form-item>
      <el-form-item
        label="就读学校："
        v-if="saveData.customer_status === 8 || saveData.customer_status === 14 "
        prop="school_name">
        <jm-dict-select v-model="saveData['school_type']" clearable class="jm-input135" type="dataset"
                        dict-type="student" name="schoolType"
                        :disabled="infoReadonly " />
        <el-input class="jm-input175" v-model="saveData['school_name']" :disabled="infoReadonly" />
      </el-form-item>
      <el-form-item
        label="就读专业："
        v-if="saveData.customer_status === 8 || saveData.customer_status === 14 "
        prop="edu_major_name">
        <jm-dict-select v-model="saveData['edu_major']" clearable class="jm-input135" type="dataset"
                        dict-type="student" name="majorType" :disabled="infoReadonly" />
        <el-input class="jm-input175" v-model="saveData['edu_major_name']" :disabled="infoReadonly " />
      </el-form-item>

      <el-form-item
        label="最高学历："
        v-if="saveData.customer_status === 8 || saveData.customer_status === 14 "
        prop="education">
        <jm-education-select clearable v-model="saveData['education']" :disabled="infoReadonly " />
      </el-form-item>
      <el-form-item
        label="意向语言："
        v-if="saveData.customer_status === 8 || saveData.customer_status === 14 "
        prop="target_lan">
        <el-checkbox-group v-model="saveData['target_lan']" :disabled="infoReadonly ">
          <el-checkbox label="日语" ></el-checkbox>
          <el-checkbox label="韩语" ></el-checkbox>
          <el-checkbox label="雅思" ></el-checkbox>
          <el-checkbox label="托福" ></el-checkbox>
          <el-checkbox label="PTE" ></el-checkbox>
          <el-checkbox label="EJU" ></el-checkbox>
          <el-checkbox label="修士" ></el-checkbox>
          <el-checkbox label="托业" ></el-checkbox>
          <el-checkbox label="预科" ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        label="学习动机（日语）："
        v-show="(saveData.customer_status === 8 || saveData.customer_status === 14)&&saveData.target_lan.some(item=>item === '日语') "
        prop="study_motive">
        <jm-dict-select v-model="saveData['study_motive']" class="jm-input220" clearable type="dataset"
                        dict-type="training" name="learningMotivation" :disabled="infoReadonly" />
      </el-form-item>
      <el-form-item
        label="学习动机（韩语）："
        v-show="(saveData.customer_status === 8 || saveData.customer_status === 14)&&saveData.target_lan.some(item=>item === '韩语') "
        prop="study_motive_kr">
        <jm-dict-select v-model="saveData['study_motive_kr']" class="jm-input220" clearable type="dataset"
                        dict-type="training" name="learningMotivation" :disabled="infoReadonly" />
      </el-form-item>
      <el-form-item
        label="学习动机（雅思、托福）："
        v-show="(saveData.customer_status === 8 || saveData.customer_status === 14)&&saveData.target_lan.some(item=>item === '雅思'||item === '托福')"
        prop="study_motive_en">
        <jm-dict-select v-model="saveData['study_motive_en']" class="jm-input220" clearable type="dataset"
                        dict-type="training" name="learningMotivation" :disabled="infoReadonly" />
      </el-form-item>

      <el-form-item
        label="客户状态："
        prop="customer_status">
        <jm-dict-select v-if="saveData.customer_status !== 7" type="dataset" dict-type="training" :disabled='customer_status'
                        name="trainingLevelType" v-model="saveData.customer_status" :filter="item => item.value !== 7"/>
        <span v-else>已报名</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchUser()">
          查询
        </el-button>
        <el-button type="primary" @click="saveUser()" :loading="saving">
          保存
        </el-button>
      </el-form-item>
      <div class="line_02"><span>快捷回访</span></div>
      <el-form-item
        label="预计下次回访时间："
        prop="visit_tk_time">
        <el-date-picker
          class="jm-input220"
          v-model="visitShadow['visit_tk_time']"
          type="datetime"
          placeholder="选择日期时间"/>
      </el-form-item>
      <el-form-item
        label="方式："
        prop="visit_kind">
        <jm-dict-select
          clearable
          class="jm-input220"
          dict="dataset.visit.way"
          v-model="visitShadow['visit_kind']"
        />
      </el-form-item>
      <el-form-item
        v-if="showActivity"
        label="活动："
        prop="activity_id">
        <el-select
          class="jm-input220"
          placeholder="请选择"
          v-model="visitShadow['activity_id']"
          clearable>
          <el-option
            v-for="item in activityList"
            :key="item.id"
            :label="item.act_title"
            :value="item.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="快捷记录：" >
        <jm-dict-select
          clearable
          class="jm-input220"
          dict="dataset.visit.quickRecord"
          v-model="visitShadow['record']"
          @change="quickFill"
        />
      </el-form-item>
      <!-- <el-form-item label="快捷记录：">
          <jm-dict-select
            clearable
            class="jm-input220"
            dict="dataset.visit.quickRecordWriterVisit"
            v-model="visitShadow['record']"
            @change="quickFill"
          />
        </el-form-item> -->
      <el-form-item
        label="回访类型："
        prop="visit_type">
        <jm-dict-select
          class="jm-input220"
          dict="dataset.visit.type"
          v-model="visitShadow['visit_type']"
        />
      </el-form-item>
      <!-- <el-form-item
          label="意向国家："
          prop="custom_hope_country"
          v-if="title === '资源激活' || (this.operateVisit === 'fibOperate' && visitShadow['visit_type'] === 2 && (([58, 66].indexOf(this.crmLevelLv) > -1) || ([131505].indexOf(this.crm_sayer) > -1)))">
          <el-select
            v-model="visitShadow['custom_hope_country']"
            class="jm-input220"
            placeholder="请选择"
            clearable>
            <el-option
              v-for="item in countriesData"
              :key="item.id"
              :label="item.value"
              :value="item.id"/>
          </el-select>
        </el-form-item> -->
      <el-form-item
        label="记录："
        prop="vist_str">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          v-model="visitShadow['vist_str']"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveVisit('visitForm')">保存</el-button>
      </el-form-item>
    </el-form>
    <div class="form-tip" >
      <p>联系型：指本次回访尝试联系学生但未成功。</p>
      <p>跟进型：指本次回访成功联系到学生，无论学生是否有意向都归类为跟进型回访。</p>
    </div>
  </div>
  <!--快捷回访 部分 E-->
</template>
<script>
import header from './compoments/header';
import { jmDictSelect, jmEducationSelect } from '@/components/tool';
import * as visitDataset from '@/dataset/visit';
import dataset from '@/dataset';

const rules = {
  userid: [
    { required: true, message: '请输入客户编码', trigger: 'blur' },
  ],
  tk_time: [
    { required: true, message: '请选择时间', trigger: 'change' },
  ],
  tk_memo: [
    { required: true, message: '请输入内容', trigger: 'blur' },
    { min: 10, message: '长度不能小于10个字符', trigger: 'blur' }
  ],
  visit_kind: [
    {
      type: 'number', required: true, message: '请选择联系方式', trigger: 'change'
    },
  ],
  visit_type: [
    {
      type: 'number', required: true, message: '请选择回访类型', trigger: 'change'
    },
  ],
  custom_hope_country: [
    {
      type: 'number', required: true, message: '请选择意向国家', trigger: 'change'
    },
  ],
  vist_str: [
    { required: true, message: '请输入内容', trigger: 'blur' },
    { min: 10, message: '长度不能小于10个字符', trigger: 'blur' }
  ],
};
export default {
  data() {
    return {
      visitShadow: {
        visit_tk_time: '', // 仅考培用，下次预约时间
        visit_kind: 0,
        record: '',
        visit_type: 0,
        custom_hope_country: '',
        vist_str: '',
        activity_id: '',
        userid: '',
      },
      userid: '',
      activityList: [],
      rules,
      countriesData: '',
      showActivity: '',
      submitUrl: '/training/visit/resource',
      studentcrmid: 0,
      customer_status: false,
      saveData: {},
      infoReadonly: false,
      saving: false,
    };
  },
  computed: {

  },
  methods: {
    // 查询客户编码
    searchUser() {
      if (this.visitShadow.userid) {
        this.$http._get({
          url: `/training/customer/resource/id/${this.visitShadow.userid}`,
        }).then((res) => {
          console.log(res);
          this.saveData = res.data;
          this.saveData.education = [res.data.education_type, res.data.education_class];
          if (res.data.customer_status === 7) {
            this.customer_status = true;
          }
        });
      } else {
        this.$message.error('查询客户编码不能为空');
      }
    },
    // 保存客户状态
    saveUser() {
      if (this.visitShadow.userid && this.saveData.customer_status) {
        console.log(this.saveData);
        if (this.saveData.customer_status === 8 || this.saveData.customer_status === 14) {
          if (!this.saveData.school_type || !this.saveData.school_name) {
            this.$message.error('请补充就读学校');
            return;
          }
          if (!this.saveData.edu_major || !this.saveData.edu_major_name) {
            this.$message.error('请补充就读专业');
            return;
          }
          if (!this.saveData.education.length) {
            this.$message.error('请补充最高学历');
            return;
          }
          if (!this.saveData.target_lan.length) {
            this.$message.error('请补充意向语言');
            return;
          }
          if (this.saveData.target_lan.some(item => item === '日语') && !this.saveData.study_motive) {
            this.$message.error('请补充学习动机（日语）');
            return;
          }
          if (this.saveData.target_lan.some(item => item === '韩语') && !this.saveData.study_motive_kr) {
            this.$message.error('请补充学习动机（韩语）');
            return;
          }
          if (this.saveData.target_lan.some(item => item === '雅思' || item === '托福') && !this.saveData.study_motive_en) {
            this.$message.error('请补充学习动机（雅思、托福）');
            return;
          }
          if (!this.saveData.study_motive) {
            this.saveData.study_motive = '';
          }
          if (!this.saveData.study_motive_kr) {
            this.saveData.study_motive_kr = '';
          }
          if (!this.saveData.study_motive_en) {
            this.saveData.study_motive_en = '';
          }
          if (this.saveData.education || this.saveData.education.length > 0) {
            [this.saveData.education_type, this.saveData.education_class] = this.saveData.education;
          }
        }
        this.saving = true;
        // return
        this.$http._post({
          url: '/training/customer/resource',
          data: this.saveData,
        }).then(() => {
          this.$message.success('保存成功');
          this.saving = false;
        }).catch((e) => {
          this.saving = false;
          if (e.data.msg) {
            this.$message.error(e.data.msg);
          } else {
            this.$message.error('保存失败');
          }
        });
      } else {
        this.$message.error('客户状态和编码不能为空');
      }
    },
    // 保存回访
    saveVisit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.userid = this.visitShadow.userid;
          let data = this.visitShadow;
          this.$http._post({
            url: this.submitUrl,
            data
          }).then(() => {
            this.$message.success('保存成功');
            this.resetForm('visitForm');
          }).catch((e) => {
            if (e.data.msg) {
              this.$message.error(e.data.msg);
            } else {
              this.$message.error('保存失败');
            }
          });
        }
      });
    },
    /**
     * 重置表单
     */
    resetForm(formName) {
      this.visitShadow = {
        visit_tk_time: '', // 仅考培用，下次预约时间
        visit_kind: 0,
        record: '',
        visit_type: 0,
        custom_hope_country: '',
        vist_str: '',
        activity_id: '',
        userid: '',
      };
      this.$refs[formName].resetFields();
      this.visitShadow.userid = this.userid;
    },
    quickFill(v) {
      visitDataset.quickRecord.forEach((item) => {
        if (item.value === v) {
          this.visitShadow.vist_str = item.label;
        }
      });
    },
    /**
     * 回访类型，感觉不同角色使用不用的类型
     */
    visitTypeFilter(item) {
      if (this.$hasPermission([91, 1, 98, 114])) {
        return true;
      }

      if (this.$hasPermission([117, 84])) {
        if (item.value === 2 || item.value === 3) {
          return true;
        }
        return false;
      }

      if (this.isNormal) {
        if (item.value === 1 || item.value === 2) {
          return true;
        }
        return false;
      }

      if (item.value === 3) {
        return true;
      }
      return false;
    }
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      // 获取字典
      this.$store.dispatch('fetchDict');
      this.$store.commit('setDatasetDict', dataset);
    });
  },
  components: {
    'wap-header': header,
    jmDictSelect,
    jmEducationSelect
  }
};
</script>

<style>

  .el-form-item__label{
    font-size: 3.5vw;
  }
  .el-form-item{
    margin-bottom: 5vw;
  }
  .form-tip{
    font-size: 3.5vw;
  }
  .el-input--medium .el-input__inner{
    height: 8vw;
    line-height: 8vw;
    font-size: 2.5vw;
  }
  .el-select-dropdown__item{
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
  }
  .el-form-item__error{
    font-size: 2.5vw;
  }
  .el-textarea__inner{
    font-size: 2.5vw;
  }
  .el-button {
    height: 7vw;
    line-height: 7vw;
    background-color: #3368fa;
    padding: 0 5vw;
    border-color: #3368fa;
    color: #fff;
    border-radius: 10px;
    margin: 3px 0;
    -webkit-transition: all linear 0.2s;
    transition: all linear 0.2s;
    font-size: 3vw;
}
.line_02{
    height: 1px;
    border-top: 1px solid #ddd;
    text-align: left;
    margin: 7vw 0;
    text-indent: 10vw;
}
.line_02 span{
    position: relative;
    top: -8px;
    background: #fff;
    padding: 0 2.5vw;
    font-size: 3.5vw;
    color: #606266;
}
</style>
